import { mapVideoStatus } from 'utilities/video/videoStatusMapper';

export const getStatusCode = (status, method, userProfile) => {
    return mapVideoStatus(
        status,
        method,
        statusCode => {
            return statusCode;
        },
        userProfile
    );
};
